<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <button class="modal-close-btn" (click)="onClose()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-4 h-4">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>

    <div class="p-4 sm:p-6 md:p-8">
      <div class="mb-4 sm:mb-6">
        <div class="text-[9px] sm:text-[10px] font-bold text-indigo-600 uppercase tracking-widest mb-1 sm:mb-2">LET'S
          GET STARTED</div>
        <h2 class="text-xl sm:text-2xl font-extrabold text-slate-900 mb-1 sm:mb-2 tracking-tight">Tell us about your
          hiring needs</h2>
        <p class="text-slate-500 text-xs sm:text-sm leading-relaxed">Share a few details, then choose whether you would
          like a tailored quote or a live product walkthrough.</p>
      </div>

      <form [formGroup]="demoForm" (ngSubmit)="onSubmit()">

        <!-- Top inputs grid -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-4 sm:mb-5">
          <div class="relative">
            <label class="block text-[10px] sm:text-[11px] font-semibold text-slate-700 mb-1 ml-1">Full name *</label>
            <div class="relative">
              <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <input type="text" formControlName="fullName" placeholder="Enter your full name"
                class="form-input has-icon"
                [class.border-red-300]="demoForm.get('fullName')?.invalid && demoForm.get('fullName')?.touched">
            </div>
            <div *ngIf="demoForm.get('fullName')?.invalid && demoForm.get('fullName')?.touched"
              class="text-red-500 text-[10px] mt-1 ml-1 flex flex-col">
              <span *ngIf="demoForm.get('fullName')?.hasError('required')">Full name is required.</span>
              <span *ngIf="!demoForm.get('fullName')?.hasError('required') && demoForm.get('fullName')?.hasError('pattern')">Please enter a valid name (letters only).</span>
              <span *ngIf="!demoForm.get('fullName')?.hasError('required') && !demoForm.get('fullName')?.hasError('pattern') && (demoForm.get('fullName')?.hasError('minlength') || demoForm.get('fullName')?.hasError('maxlength'))">Name must be between 2 and 50 characters.</span>
            </div>
          </div>

          <div class="relative">
            <label class="block text-[10px] sm:text-[11px] font-semibold text-slate-700 mb-1 ml-1">Work email *</label>
            <div class="relative">
              <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              <input type="email" formControlName="workEmail" placeholder="Enter your work email"
                class="form-input has-icon"
                [class.border-red-300]="demoForm.get('workEmail')?.invalid && demoForm.get('workEmail')?.touched">
            </div>
            <div *ngIf="demoForm.get('workEmail')?.invalid && demoForm.get('workEmail')?.touched"
              class="text-red-500 text-[10px] mt-1 ml-1 flex flex-col">
              <span *ngIf="demoForm.get('workEmail')?.hasError('required')">Work email is required.</span>
              <span *ngIf="!demoForm.get('workEmail')?.hasError('required') && (demoForm.get('workEmail')?.hasError('email') || demoForm.get('workEmail')?.hasError('pattern'))">Invalid email.</span>
              <span *ngIf="!demoForm.get('workEmail')?.hasError('required') && !demoForm.get('workEmail')?.hasError('email') && !demoForm.get('workEmail')?.hasError('pattern') && demoForm.get('workEmail')?.hasError('maxlength')">Email must be under 100 characters.</span>
            </div>
          </div>

          <div class="relative">
            <label class="block text-[10px] sm:text-[11px] font-semibold text-slate-700 mb-1 ml-1">Phone number</label>
            <div class="relative">
              <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path
                  d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                </path>
              </svg>
              <input type="tel" formControlName="phoneNumber" placeholder="Enter your phoneNumber"
                (input)="allowNumbersOnly($event)"
                class="form-input has-icon"
                [class.border-red-300]="demoForm.get('phoneNumber')?.invalid && demoForm.get('phoneNumber')?.touched">
            </div>
            <div *ngIf="demoForm.get('phoneNumber')?.invalid && demoForm.get('phoneNumber')?.touched"
              class="text-red-500 text-[10px] mt-1 ml-1 flex flex-col">
              <span *ngIf="demoForm.get('phoneNumber')?.hasError('required')">Phone number is required.</span>
              <span *ngIf="!demoForm.get('phoneNumber')?.hasError('required') && (demoForm.get('phoneNumber')?.hasError('pattern') || demoForm.get('phoneNumber')?.hasError('minlength') || demoForm.get('phoneNumber')?.hasError('maxlength'))">Please enter exactly 10 digits.</span>
            </div>
          </div>

          <div class="relative">
            <label class="block text-[10px] sm:text-[11px] font-semibold text-slate-700 mb-1 ml-1">Company name
              *</label>
            <div class="relative">
              <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
                <path d="M9 22v-4h6v4"></path>
                <path d="M8 6h.01"></path>
                <path d="M16 6h.01"></path>
                <path d="M12 6h.01"></path>
                <path d="M12 10h.01"></path>
                <path d="M12 14h.01"></path>
                <path d="M16 10h.01"></path>
                <path d="M16 14h.01"></path>
                <path d="M8 10h.01"></path>
                <path d="M8 14h.01"></path>
              </svg>
              <input type="text" formControlName="companyName" placeholder="Enter your company name"
                class="form-input has-icon"
                [class.border-red-300]="demoForm.get('companyName')?.invalid && demoForm.get('companyName')?.touched">
            </div>
            <div *ngIf="demoForm.get('companyName')?.invalid && demoForm.get('companyName')?.touched"
              class="text-red-500 text-[10px] mt-1 ml-1 flex flex-col">
              <span *ngIf="demoForm.get('companyName')?.hasError('required')">Company name is required.</span>
              <span *ngIf="!demoForm.get('companyName')?.hasError('required') && (demoForm.get('companyName')?.hasError('minlength') || demoForm.get('companyName')?.hasError('maxlength'))">Name must be between 2 and 100 characters.</span>
            </div>
          </div>
        </div>



        <div class="border-t border-slate-100 my-4 sm:my-6"></div>

        <div class="mb-4 sm:mb-6">
          <h3 class="text-xs font-bold text-slate-900 mb-1">How can we help?</h3>
          <p class="text-[10px] sm:text-xs text-slate-500 mb-2 sm:mb-3">Select the experience that suits you best.</p>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
            <div class="selection-card" [class.active]="selectedOption === 'demo'" (click)="setOption('demo')">
              <div class="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
                [class.bg-indigo-50]="selectedOption === 'demo'" [class.text-indigo-600]="selectedOption === 'demo'"
                [class.bg-slate-50]="selectedOption !== 'demo'" [class.text-slate-400]="selectedOption !== 'demo'">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-4 h-4">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </div>
              <div class="flex-1">
                <div class="text-sm font-bold" [class.text-indigo-900]="selectedOption === 'demo'"
                  [class.text-slate-700]="selectedOption !== 'demo'">Book a demo</div>
              </div>
              <div class="w-4 h-4 rounded-full border-2 flex items-center justify-center"
                [class.border-indigo-600]="selectedOption === 'demo'"
                [class.border-slate-300]="selectedOption !== 'demo'">
                <div *ngIf="selectedOption === 'demo'" class="w-2 h-2 rounded-full bg-indigo-600"></div>
              </div>
            </div>

            <div class="selection-card" [class.active]="selectedOption === 'quote'" (click)="setOption('quote')">
              <div class="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
                [class.bg-indigo-50]="selectedOption === 'quote'" [class.text-indigo-600]="selectedOption === 'quote'"
                [class.bg-slate-50]="selectedOption !== 'quote'" [class.text-slate-400]="selectedOption !== 'quote'">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="w-4 h-4">
                  <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                  <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                </svg>
              </div>
              <div class="flex-1">
                <div class="text-sm font-bold" [class.text-indigo-900]="selectedOption === 'quote'"
                  [class.text-slate-700]="selectedOption !== 'quote'">Get a quote</div>
              </div>
              <div class="w-4 h-4 rounded-full border-2 flex items-center justify-center"
                [class.border-indigo-600]="selectedOption === 'quote'"
                [class.border-slate-300]="selectedOption !== 'quote'">
                <div *ngIf="selectedOption === 'quote'" class="w-2 h-2 rounded-full bg-indigo-600"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-3 sm:mb-4">
          <div>
            <label class="block text-[10px] sm:text-[11px] font-semibold text-slate-700 mb-1 ml-1">Company size
              *</label>
            <select formControlName="companySize" class="form-input"
              [class.border-red-300]="demoForm.get('companySize')?.invalid && demoForm.get('companySize')?.touched">
              <option value="" disabled selected>Select an option</option>
              <option value="1-50 employees">1-50 employees</option>
              <option value="51-200 employees">51-200 employees</option>
              <option value="201-500 employees">201-500 employees</option>
              <option value="501+ employees">501+ employees</option>
            </select>
            <div *ngIf="demoForm.get('companySize')?.invalid && demoForm.get('companySize')?.touched"
              class="text-red-500 text-[10px] mt-1 ml-1">
              Company size is required.
            </div>
          </div>
          <div>
            <label class="block text-[10px] sm:text-[11px] font-semibold text-slate-700 mb-1 ml-1">Hiring volume
              *</label>
            <select formControlName="hiringVolume" class="form-input"
              [class.border-red-300]="demoForm.get('hiringVolume')?.invalid && demoForm.get('hiringVolume')?.touched">
              <option value="" disabled selected>Select an option</option>
              <option value="1-10 hires/month">1-10 hires/month</option>
              <option value="11-50 hires/month">11-50 hires/month</option>
              <option value="50+ hires/month">50+ hires/month</option>
            </select>
            <div *ngIf="demoForm.get('hiringVolume')?.invalid && demoForm.get('hiringVolume')?.touched"
              class="text-red-500 text-[10px] mt-1 ml-1">
              Hiring volume is required.
            </div>
          </div>
        </div>

        <div class="mb-4 sm:mb-5">
          <label class="block text-[10px] sm:text-[11px] font-semibold text-slate-700 mb-1 ml-1">Anything else we should
            know? <span class="text-slate-400 font-normal">Optional</span></label>
          <textarea formControlName="additionalInfo" rows="3"
            placeholder="Tell us about your hiring needs, hiring goals, challenges, or expected hiring volume."
            class="form-input resize-none"
            [class.border-red-300]="demoForm.get('additionalInfo')?.invalid && demoForm.get('additionalInfo')?.touched"></textarea>
          <div *ngIf="demoForm.get('additionalInfo')?.invalid && demoForm.get('additionalInfo')?.touched"
            class="text-red-500 text-[10px] mt-1 ml-1 flex flex-col">
            <span *ngIf="demoForm.get('additionalInfo')?.hasError('maxlength')">Cannot exceed 500 characters.</span>
          </div>
        </div>

        <div *ngIf="selectedOption === 'demo'" class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-4 sm:mb-5">
          <div>
            <label class="block text-[10px] sm:text-[11px] font-semibold text-slate-700 mb-1 ml-1">Preferred demo
              date</label>
            <input type="date" formControlName="demoDate" [min]="minDate" class="form-input text-slate-500"
              [class.border-red-300]="demoForm.get('demoDate')?.invalid && demoForm.get('demoDate')?.touched">
            <div *ngIf="demoForm.get('demoDate')?.invalid && demoForm.get('demoDate')?.touched"
              class="text-red-500 text-[10px] mt-1 ml-1">
              Demo date is required.
            </div>
          </div>
          <div>
            <label class="block text-[10px] sm:text-[11px] font-semibold text-slate-700 mb-1 ml-1">Preferred
              time</label>
            <div [class.has-error]="demoForm.get('demoTime')?.invalid && demoForm.get('demoTime')?.touched">
              <p-calendar formControlName="demoTime" [timeOnly]="true" hourFormat="12" [showSeconds]="true"
                placeholder="Select a time" styleClass="w-full block" panelStyleClass="custom-time-picker"
                [readonlyInput]="true" [keepInvalid]="true" inputStyleClass="form-input text-slate-500 w-full"
                [minDate]="minTimeConstraint || undefined">
              </p-calendar>
            </div>
            <div *ngIf="demoForm.get('demoTime')?.invalid && demoForm.get('demoTime')?.touched"
              class="text-red-500 text-[10px] mt-1 ml-1">
              <span *ngIf="demoForm.get('demoTime')?.errors?.['required']">Demo time is required.</span>
            </div>
          </div>
        </div>

        <!-- Alerts -->
        <div *ngIf="errorMessage"
          class="mb-4 sm:mb-5 p-3 rounded-lg bg-red-50 text-red-600 text-xs sm:text-sm font-medium border border-red-100 flex items-start gap-2">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            class="w-4 h-4 flex-shrink-0 mt-0.5">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <span>{{ errorMessage }}</span>
        </div>


        <div class="border-t border-slate-100 pt-4 sm:pt-5 mt-2 sm:mt-3 flex items-center justify-between">
          <button type="button" (click)="onClose()"
            class="text-xs sm:text-sm font-semibold text-slate-500 hover:text-slate-900 transition-colors">Cancel</button>
          <button type="submit" [disabled]="isSubmitting"
            class="bg-indigo-600 hover:bg-indigo-700 text-white font-bold text-sm px-6 py-2.5 rounded-lg transition-colors flex items-center gap-2"
            [class.opacity-70]="isSubmitting" [class.cursor-not-allowed]="isSubmitting">
            <svg *ngIf="isSubmitting" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
              xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
              </path>
            </svg>
            {{ isSubmitting ? 'Submitting...' : (selectedOption === 'demo' ? 'Schedule demo' : 'Request quote') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>